/* ==========================================================================
   Community Group Filters
   ========================================================================== */

const $mapLink = $(".js-map-filter.map");
const $listLink = $(".js-map-filter.list");
const $gridLink = $(".js-map-filter.grid");
const $mapView = $("#mapView");
const $listView = $("#listView");
const $gridView = $("#gridView");

// Event handler for all link clicks
$(".js-map-filter").on('click', function (e) {
    e.preventDefault();
    // Toggle active class for the clicked link
    $(this).toggleClass("is-active");

    // Remove active class from other links
    $(".js-map-filter").not(this).removeClass("is-active");

    // Show/hide views based on the clicked link
    if ($mapLink.hasClass("is-active")) {
        $mapView.show();
        $listView.hide();
        $gridView.hide();
    } else if ($listLink.hasClass("is-active")) {
        $mapView.hide();
        $listView.show();
        $gridView.hide();
    } else if ($gridLink.hasClass("is-active")) {
        $mapView.hide();
        $listView.hide();
        $gridView.show();
    }
});

$(document).ready(function () {
    $(".js-communitygroups-filterbtns .button[data-filter='all']").addClass("is-active");
    communityFilterSelection();
});

$(".js-communitygroups-filterbtns .button").not(".disabled").on('click', function (e) {
    $(this).toggleClass("is-active");
    if ($(this).hasClass("is-active")) {
        $(this).removeClass("button--light");
    } else {
        $(this).addClass("button--light");
    }
    if ($(this).data("filter") != "all") {
        $(".js-communitygroups-filterbtns .button[data-filter='all']").removeClass("is-active").addClass("button--light");
    } else {
        $(".js-communitygroups-filterbtns .button[data-filter!='all']").removeClass("is-active").removeClass("button--light");
    }
    communityFilterSelection();
});

$(".js-communitygroups-filterbtns .checkbox").not(".disabled").on('click', function (e) {
    $(this).toggleClass("is-active");
    $(".js-communitygroups-filterbtns .button[data-filter='all']").removeClass("is-active").addClass("button--light");
    communityFilterSelection();
});

function communityFilterSelection() {
    let anyActive = false;
    if ($('.mapboxgl-marker-anchor-center').length) {
        $('.mapboxgl-marker-anchor-center').hide();
    }
    if ($('.section--communitygroups__item').length) {
        $('.section--communitygroups__item').hide();
    }
    $(".js-communitygroups-filterbtns .button.is-active, .js-communitygroups-filterbtns .checkbox.is-active").each(function (index) {
        anyActive = true;
        let filter = $(this).data("filter");
        if (filter == "all") filter = "";
        $('.section--communitygroups__item').each(function (index) {
            if ($(this).data("filter").indexOf(filter) > -1) $(this).show();
        });
        $('.mapboxgl-marker-anchor-center').each(function (index) {
            if ($(this).data("filter").indexOf(filter) > -1) $(this).show();
        });
    });

    if (!anyActive) {
        $('.section--communitygroups__item').show();
        $('.mapboxgl-marker-anchor-center').show();
        $(".js-communitygroups-filterbtns .button[data-filter='all']").removeClass("button--light");
    }
}
